import { render, staticRenderFns } from "./BxAccountList.vue?vue&type=template&id=6b42d950&scoped=true&"
import script from "./BxAccountList.vue?vue&type=script&lang=js&"
export * from "./BxAccountList.vue?vue&type=script&lang=js&"
import style0 from "./BxAccountList.vue?vue&type=style&index=0&id=6b42d950&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b42d950",
  null
  
)

export default component.exports